export const PRIVACY_SECTIONS = [
  {
    title: "Responsable de tus datos personales",
    paragraphs: [
      "Carlos García Rincón, con domicilio en 33 Oriente 1614, Sección Bandini, C.P. 72503, Puebla, Puebla, México, es responsable del uso, tratamiento y protección de los datos personales que nos proporcionas a través de este sitio web, de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).",
    ],
  },
  {
    title: "¿Qué datos personales recabamos?",
    paragraphs: [
      "A través del formulario de agendamiento de citas de este sitio recabamos: nombre completo, teléfono/WhatsApp, correo electrónico, servicio de interés, fecha y horario preferido, y comentarios adicionales (en caso de que los proporciones).",
      "No recabamos datos de salud a través de este sitio web. Cualquier dato clínico se recaba directamente en la Clínica de Atención Bucal de la Facultad de Odontología de la UATx, mediante el proceso de consentimiento informado que se firma de forma presencial, y su tratamiento corresponde a dicha institución conforme a la NOM-004-SSA3-2012.",
    ],
  },
  {
    title: "¿Para qué utilizamos tus datos personales?",
    paragraphs: ["Usamos los datos que nos proporcionas a través del formulario para:"],
    list: [
      "Contactarte para confirmar, reagendar o dar seguimiento a tu cita.",
      "Compartir tus datos de contacto y tu solicitud con el personal de la Clínica de Atención Bucal de la Facultad de Odontología UATx, para que puedan atenderte — es el único destinatario de esta información.",
      "Enviarte recordatorios relacionados con tu cita.",
    ],
    after: [
      "No usamos, vendemos ni compartimos tus datos personales con ninguna otra persona, empresa o institución distinta a la señalada arriba, salvo obligación legal.",
    ],
  },
  {
    title: "Uso de cookies y tecnologías de rastreo (Meta Pixel)",
    paragraphs: [
      [
        "Este sitio utiliza el Meta Pixel (Facebook/Instagram) para medir el desempeño de nuestros anuncios y saber cuándo alguien agenda una cita después de ver uno de ellos. Esta herramienta recaba automáticamente datos de navegación (como tu dirección IP, el dispositivo que usas y tu interacción con la página) y los comparte con Meta Platforms, Inc., conforme a su propia política de privacidad. Puedes conocer más en ",
        { label: "facebook.com/privacy/policy", href: "https://www.facebook.com/privacy/policy", testId: "privacy-meta-link" },
        " y gestionar tus preferencias de publicidad desde la configuración de anuncios de tu cuenta de Meta.",
      ],
    ],
  },
  {
    title: "¿Cómo ejercer tus derechos ARCO (Acceso, Rectificación, Cancelación u Oposición)?",
    paragraphs: [
      [
        "Escríbenos a ",
        { label: "rebecaivonnegarciasanchez@gmail.com", href: "mailto:rebecaivonnegarciasanchez@gmail.com" },
        " o comunícate al ",
        { label: "222 492 3409", href: "tel:+522224923409" },
        ", indicando tu nombre completo y el derecho que deseas ejercer. Responderemos en un plazo máximo de 20 días hábiles, conforme a la LFPDPPP.",
      ],
    ],
  },
  {
    title: "Cambios al aviso de privacidad",
    paragraphs: ["Nos reservamos el derecho de modificar este aviso. Cualquier cambio se publicará en esta misma página."],
  },
];
